import * as actions from '../../actions/admin/adminUserActions.js'

const initialState = {
  profileFor: null,
  reportId: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_PROFILE: {
      return {
        ...state,
        profileFor: action.userId,
        reportId: action.reportId ? action.reportId : 1
      }
    }

    case actions.CLEAR_PROFILE: {
      const profileFor = state.profileFor

      if (profileFor) {
        //console.log("Adding profileFor", userId, "as", action.restCall.result)
        return {
          ...state,
          profileFor: null,
          reportId: null
        }
      }

      return state
    }

    default:
      return state
  }
}

export default reducers
